export default __webpack_public_path__ + "static/media/metabase_banner.7d34540d.jpeg";